// extracted by mini-css-extract-plugin
export default {"loader":"ParticlesBg_loader__zyyjO"};